<template>
  <div class="udan-ems-wrapper">
    <el-container>
      <el-header>
        <div class="layout-header-main">
          <div class="layout-header-left" :class="language === 'en' ? 'layout-header-left-en' : ''">
            <el-image v-if="homeLogoUrl" :src="homeLogoUrl" @error="handleError">
              <div slot="error" class="image-slot">
                <span v-if="homeLogoTitle">{{ homeLogoTitle }}</span>
                <span v-else>{{ title }}</span>
              </div>
            </el-image>
            <span v-else-if="homeLogoTitle">{{ homeLogoTitle }}</span>
            <span v-else>{{ title }}</span>
          </div>
          <div class="layout-header-right">
            <el-row>
              <el-col :span="14">
                <div class="layout-header-notice" v-permission="['ems:switchCustomer:switch']">
                  <div class="user-title">{{ $t('客户名称') }}：</div>
                  <el-select
                    v-model="customerId"
                    filterable
                    clearable
                    @change="handleChange"
                    remote
                    :remote-method="getDatas"
                    @clear="setFilter"
                    @focus="setFilter"
                    popper-class="eloption"
                    :popper-append-to-body="true"
                  >
                    <div class="anchor-list">
                      <span v-for="letter in indexLetters" :key="letter" @click="scrollToGroup(letter, $event)" :style="{ color: activeLetter === letter ? '#409eff' : '#909399' }">
                        {{ letter }}
                      </span>
                    </div>
                    <el-option-group v-for="group in groupedFilterList" :key="group.index" :label="group.index" :ref="`group-${group.index}`">
                      <el-option v-for="item in group.data" :key="item.id" :label="item.nameZh" :value="item.id" />
                    </el-option-group>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="5" v-if="DescTip === 'open' && language != 'en'" class="layout-header-update-description">
                <div class="update-desc" @click="clickdesc" id="descbox">
                  <div class="desc-left">
                    <div class="icondiv">
                      <svg-icon :icon-file-name="'layout-desc'" />
                    </div>
                    <div class="title">
                      {{ $t('平台功能更新说明') }}
                    </div>
                  </div>
                  <div class="desc-right">
                    <div class="desc-search">{{ $t('查看') }}</div>
                    <div class="desc-close" id="closbtn" @click.stop="closeDesc">
                      <svg-icon :icon-file-name="'layout-close'" />
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="5" v-else />
              <el-col :span="5" class="layout-header-info-language">
                <div class="language-select">
                  <el-select v-model="language" :placeholder="$t('请选择')" @change="choose(language)" class="language-select-input">
                    <template #prefix>
                      <span style="padding-left: 5px">
                        <svg-icon :icon-file-name="'lang'" />
                      </span>
                    </template>
                    <el-option v-for="(item, key, i) in messages" :key="i" :label="item.language" :value="key" />
                  </el-select>
                </div>
                <el-divider direction="vertical" />
                <div class="layout-header-info">
                  <div><el-avatar :src="avatar" /></div>
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      {{ userName }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="3">{{ $t('个人信息') }}</el-dropdown-item>
                      <el-dropdown-item command="2">{{ $t('修改密码') }}</el-dropdown-item>
                      <el-dropdown-item command="1">{{ $t('退出登录') }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-header>
      <el-container class="udan-ems-container">
        <el-aside :class="language === 'en' ? 'el-aside-en' : 'el-aside'">
          <el-menu mode="vertical" :default-active="activeMenu" @select="handleSelect" class="el-menu-vertical-demo" :collapse="isCollapse" collapse-transition>
            <el-menu-item @click="handleScreen" v-permission="['ems:bigScreen:view']">
              <svg-icon :icon-file-name="activeMenu === '/dataScreen' ? 'screen-active' : 'screen'" />
              <span slot="title" v-tooltip>{{ $t('数据大屏') }}</span>
            </el-menu-item>
            <el-menu-item index="/index" v-permission="['ems:multiStation']">
              <svg-icon :icon-file-name="activeMenu === '/index' ? 'all-active' : 'all'" />
              <span slot="title" v-tooltip>{{ $t('多站总览') }}</span>
            </el-menu-item>

            <div v-if="location.indexOf('ujoinwe') == -1">
              <el-menu-item index="/stationCard" v-permission="['ems:station:card:view']">
                <svg-icon :icon-file-name="activeMenu === '/stationCard' ? 'card-active' : 'card'" />
                <span slot="title" v-tooltip>{{ $t('站点卡片') }}</span>
              </el-menu-item>
            </div>
            <div v-show="!isCollapse" class="el-menu-item-group__title" v-permission="['ems:singleStation', 'ems:stationSystem', 'ems:deviceMonitor', 'ems:alarm']">{{ $t('单站数据') }}</div>
            <div v-show="isCollapse" class="close-title" v-permission="['ems:singleStation', 'ems:stationSystem', 'ems:deviceMonitor', 'ems:alarm']"><div class="line"></div></div>
            <el-menu-item index="/stationsOverview" v-permission="['ems:singleStation']">
              <svg-icon :icon-file-name="activeMenu === '/stationsOverview' ? 'one-active' : 'one'" />
              <span slot="title" v-tooltip>{{ $t('电站概览') }}</span>
            </el-menu-item>
            <el-menu-item index="/stationSystem" v-permission="['ems:stationSystem']">
              <svg-icon :icon-file-name="activeMenu === '/stationSystem' ? 'station-active' : 'station'" />
              <span slot="title">{{ $t('站点系统') }}</span>
            </el-menu-item>
            <el-menu-item index="/allDeviceMonitor" v-permission="['ems:deviceMonitor']">
              <svg-icon :icon-file-name="activeMenu === '/allDeviceMonitor' ? 'monitor-active' : 'monitor'" />
              <span slot="title" v-tooltip>{{ $t('设备监控') }}</span>
            </el-menu-item>
            <el-menu-item index="/faultWarning" v-permission="['ems:alarm']">
              <svg-icon :icon-file-name="activeMenu === '/faultWarning' ? 'warning-active' : 'warning'" />
              <span slot="title">{{ $t('站点告警') }}</span>
            </el-menu-item>
            <!-- <el-menu-item index="/faultWarning2" v-permission="['ems:alarm']">
              <svg-icon :icon-file-name="activeMenu === '/faultWarning2' ? 'warning-active' : 'warning'" />
              <span slot="title">{{ $t('故障告警') }}</span>
            </el-menu-item> -->
            <el-menu-item index="/elecPriceManage" v-permission="['ems:electrovalence:manage']">
              <svg-icon :icon-file-name="activeMenu === '/elecPriceManage' ? 'price-active' : 'price'" />
              <span slot="title" v-tooltip>{{ $t('电价管理') }}</span>
            </el-menu-item>
            <div v-show="!isCollapse" class="el-menu-item-group__title" v-permission="['ems:power:report', 'ems:profit:report']">{{ $t('统计报表') }}</div>
            <div v-show="isCollapse" class="close-title" v-permission="['ems:power:report', 'ems:profit:report']"><div class="line"></div></div>
            <el-menu-item index="/reportPower" v-permission="['ems:power:report']">
              <svg-icon :icon-file-name="activeMenu === '/reportPower' ? 'power-active' : 'power'" />
              <span slot="title" v-tooltip>{{ $t('电量报表') }}</span>
            </el-menu-item>
            <el-menu-item index="/reportProfit" v-permission="['ems:profit:report']">
              <svg-icon :icon-file-name="activeMenu === '/reportProfit' ? 'profit-active' : 'profit'" />
              <span slot="title" v-tooltip>{{ $t('收益报表') }}</span>
            </el-menu-item>

            <!-- 运维管理 -->
            <div v-show="!isCollapse" class="el-menu-item-group__title" v-permission="['ems:workOrder:manage']">
              {{ $t('运维管理') }}
            </div>
            <div v-show="isCollapse" class="close-title" v-permission="['ems:workOrder:manage']"><div class="line"></div></div>
            <el-menu-item index="/workOrder" v-permission="['ems:workOrder:manage']">
              <svg-icon :icon-file-name="activeMenu === '/workOrder' ? 'work-order-active' : 'work-order'" />
              <span slot="title" v-tooltip>{{ $t('工单管理') }}</span>
              <!-- <el-tag type="warning" v-show="!isCollapse">NEW</el-tag> -->
            </el-menu-item>
            <!-- 告警中心 -->
            <div v-show="!isCollapse" class="el-menu-item-group__title" v-permission="['ems:alarmMonitor']">
              {{ $t('告警中心') }}
            </div>
            <div v-show="isCollapse" class="close-title" v-permission="['ems:alarmMonitor']"><div class="line"></div></div>
            <el-menu-item index="/alarmMonitor" v-permission="['ems:alarmMonitor']">
              <svg-icon :icon-file-name="activeMenu === '/alarmMonitor' ? 'alarm-monitor-active' : 'alarm-monitor'" />
              <span slot="title" v-tooltip>{{ $t('告警监控') }}</span>
              <!-- <el-tag type="warning" v-show="!isCollapse">NEW</el-tag> -->
            </el-menu-item>
            <div v-show="!isCollapse" class="el-menu-item-group__title" v-permission="['ems:station:manage', 'ems:electrovalence:manage', 'ems:user:manage', 'ems:emsSystem:manage']">
              {{ $t('系统管理') }}
            </div>
            <div v-show="isCollapse" class="close-title" v-permission="['ems:station:manage', 'ems:electrovalence:manage', 'ems:user:manage', 'ems:emsSystem:manage']"><div class="line"></div></div>
            <el-menu-item index="/powerStationManage" v-permission="['ems:station:manage']">
              <svg-icon :icon-file-name="activeMenu === '/powerStationManage' ? 'power-station-active' : 'power-station'" />
              <span slot="title" v-tooltip>{{ $t('电站管理') }}</span>
            </el-menu-item>
            <el-menu-item index="/stencilManage" v-permission="['ems:template:manage']">
              <svg-icon :icon-file-name="activeMenu === '/stencilManage' ? 'template-active' : 'template'" />
              <span slot="title">{{ $t('公共模版') }}</span>
            </el-menu-item>
            <el-menu-item index="/userManage" v-permission="['ems:user:manage']">
              <svg-icon :icon-file-name="activeMenu === '/userManage' ? 'user-active' : 'user'" />
              <span slot="title" v-tooltip>{{ $t('账号管理') }}</span>
            </el-menu-item>
            <el-menu-item index="/systemManage" v-permission="['ems:emsSystem:manage']">
              <svg-icon :icon-file-name="activeMenu === '/systemManage' ? 'system-active' : 'system'" />
              <span slot="title" v-tooltip>{{ $t('系统管理') }}</span>
            </el-menu-item>
          </el-menu>
          <div class="fold">
            <div class="open-close" @click="clickFold">
              <div v-show="isCollapse"><i class="el-icon-s-unfold"></i></div>
              <div v-show="!isCollapse">
                <i class="el-icon-s-fold"></i><span>{{ $t('收起') }}</span>
              </div>
            </div>
          </div>
        </el-aside>
        <el-main :class="isCollapse ? 'el-main-fold' : language === 'en' ? 'el-main-open-en' : 'el-main-open'" id="home_main" ref="scrollMenuRef" @scroll.passive="handleScroll($event)">
          <div class="scroll" v-show="isActive">
            <div id="toTop" class="top" @click="toTop(step)"><i class="el-icon-caret-top"></i></div>
          </div>
          <transition name="fade" mode="out-in">
            <RouterView id="main-con" :key="collapse" />
          </transition>
        </el-main>
      </el-container>
    </el-container>
    <!--修改密码-->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :title="$t('修改密码')" width="500px" @close="handlePwdClose()" class="dialog-amend">
      <el-form ref="pwdFormRef" :model="passwordForm" :rules="pwdRules">
        <el-form-item :label="$t('原密码') + '：'" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" :placeholder="$t('请输入原密码')" />
        </el-form-item>
        <el-form-item :label="$t('新密码') + '：'" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" :placeholder="$t('请输入新密码')" />
        </el-form-item>
        <el-form-item :label="$t('确认新密码') + '：'" prop="repeatPwd">
          <el-input v-model="passwordForm.repeatPwd" type="password" :placeholder="$t('请输入确认密码')" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="handlePwdClose()">{{ $t('取消') }}</el-button>
        <el-button :loading="savePwdLoading" type="primary" @click="handlePwdSave()">{{ $t('确定') }}</el-button>
      </template>
    </el-dialog>
    <update-dialog ref="updateDialog" />
    <personal-info-dialog ref="personalInfoDialog" />
  </div>
</template>

<script>
  import Fuse from 'fuse.js'
  import { messages } from '@/lang'
  import { logout, userModifyPwd, checkToken } from '@/api/user'
  import { getWebConfig, getListCustomers, switchCustomer } from '@/api/common'
  import { getCookie, setCookie, removeStationsId, removeEmsId, removeToken, getToken } from '@/utils/auth'
  import { isPassword } from '@/utils/validate'
  import UpdateDialog from '../components/layoutModule/updateDialog'
  import PersonalInfoDialog from '../components/layoutModule/personalInfoDialog.vue'
  export default {
    name: 'Layouts',
    components: { UpdateDialog, PersonalInfoDialog },
    data() {
      var pwdValid = (rule, value, callback) => {
        let _this = this
        if (value === '') {
          callback(new Error(_this.$t('请输入确认密码')))
        } else if (value !== _this.passwordForm.newPassword) {
          callback(new Error(_this.$t('两次密码不一致请重新输入')))
        } else {
          callback()
        }
      }
      return {
        location: '',
        fuse: null,
        loading: false,
        dialogVisible: false,
        DescTip: getCookie('setDescTip') || 'open',
        content: '',
        messages: messages,
        language: '',
        activeLetter: '',
        permission: [],
        routes: this.$store.state.routes || [],
        userName: this.$store.state.userName || getCookie('UserName'),
        avatar: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
        isCollapse: JSON.parse(getCookie('isCollapse')) || false,
        indexLetters: ['#'],
        collapse: null,
        user: getCookie('config') || '',
        title: '',
        isActive: false,
        step: 40,
        tooltipFlag: false,
        homeLogoUrl: '',
        homeLogoTitle: '',
        bigScreenMapRegion: '',
        customerId: '',
        customerList: [],
        filterList: [],
        dialogFormVisible: false, // 密码重置校验
        savePwdLoading: false, // 密码重置保存
        passwordForm: {
          oldPassword: '', // 原密码
          newPassword: '', // 密码
          repeatPwd: '' // 确认密码
        },
        timer: null,
        pwdRules: {
          oldPassword: [
            {
              required: true,
              message: this.$t('请输入原密码'),
              trigger: 'blur'
            }
          ],
          newPassword: [
            {
              required: true,
              message: this.$t('请输入密码'),
              trigger: 'blur'
            },
            { validator: isPassword, trigger: 'blur' }
          ],
          repeatPwd: [
            {
              required: true,
              message: this.$t('请输入确认密码'),
              trigger: 'blur'
            },
            { validator: pwdValid, trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      activeMenu: {
        get() {
          const route = this.$route
          const { meta, path } = route
          if (meta.activeMenu) {
            return meta.activeMenu
          } else {
            return path
          }
        },
        set() {}
      },
      groupedFilterList() {
        // 排序后的副本，不影响原始数据
        const sortedList = this.filterList.slice().sort((a, b) => {
          return a.nameZhPy.localeCompare(b.nameZhPy)
        })

        // 存储分组后的数据
        const groupedData = {}
        sortedList.forEach((item) => {
          // 获取首字母
          const firstLetter = item.nameZhPy.charAt(0).toUpperCase()
          // 如果首字母不存在则创建一个新的数组
          if (!groupedData[firstLetter]) {
            groupedData[firstLetter] = []
          }
          // 将当前项添加到对应的分组中
          groupedData[firstLetter].push(item)
        })
        const result = []
        for (let letter in groupedData) {
          result.push({
            index: letter,
            data: groupedData[letter]
          })
        }
        return result
      }
    },
    watch: {
      $route(to) {
        //监听路由变化的时候使滚动条回到顶部
        document.getElementById('home_main').scrollTo(0, 0)
      },
      groupedFilterList: {
        handler(newValue, oldValue) {
          this.indexLetters = []
          this.groupedFilterList.forEach((group) => {
            if (!this.indexLetters.includes(group.index)) {
              this.indexLetters.push(group.index)
            }
          })
          this.indexLetters.sort()
        },
        immediate: true // 立即执行一次
      }
    },
    created() {
      this.setLanguage()
    },
    mounted() {
      this.location = location.href
      this.permission = getCookie('Permission').split(',')
      if (this.permission.includes('ems:switchCustomer:switch')) {
        this.getListCustomers()
      }
      window.addEventListener('scroll', this.handleScroll, true)
      this.userWebConfig()
      window.addEventListener('resize', function () {
        const activeEl = document.querySelector('.el-tabs__item.is-top.is-active')
        const lineEl = document.querySelector('.el-tabs__active-bar.is-top')
        if (activeEl) {
          const style = getComputedStyle(activeEl)
          const pl = style.paddingLeft.match(/\d+/)[0] * 1
          const pr = style.paddingRight.match(/\d+/)[0] * 1
          const w = style.width.match(/\d+/)[0] * 1
          lineEl.style.transform = 'translateX(' + (activeEl.offsetLeft + pl) + 'px)'
          lineEl.style.width = w - pl - pr + 'px'
        }
      })

      this.timer = setInterval(() => {
        checkToken({})
          .then((res) => {
            if (res.data.code == 200) {
              let status = res.data.data.status
              if (status == 1) {
                removeToken('Token')
                this.$message({
                  message: this.$t('登录已过期，请重新登录'),
                  type: 'error',
                  showClose: true,
                  duration: 0,
                  customClass: 'stale-dated'
                })
                this.$store.dispatch('resetAll')
                this.$router.push('/login')
              }
            }
          })
          .catch((error) => {})
      }, 1000 * 60 * 5)
    },
    methods: {
      // 点击字母时滚动到相应分组
      scrollToGroup(letter) {
        this.activeLetter = letter
        const targetSelect = this.groupedFilterList.find((item) => {
          return item.index === letter
        })
        const groupElement = this.$refs[`group-${targetSelect.index}`]
        if (groupElement && groupElement.length > 0) {
          groupElement[0].$el.scrollIntoView({ behavior: 'smooth' })
        }
      },
      initFuse(list) {
        this.fuse = new Fuse(list, {
          shouldSort: true,
          threshold: 0.1,
          location: 0,
          distance: 1000,
          maxPatternLength: 9999999,
          minMatchCharLength: 1,
          keys: [
            {
              name: 'nameZh',
              weight: 0.7
            },
            {
              name: 'nameEn',
              weight: 0.6
            },
            {
              name: 'nameZhPy',
              weight: 0.5
            },
            {
              name: 'nameZhFlpy',
              weight: 0.4
            }
          ]
        })
      },
      /* 获取选项列表 */
      getDatas(key) {
        this.loading = true
        if (key == '') {
          this.loading = false
          this.filterList = this.customerList
        } else {
          this.loading = false
          this.filterList = this.fuse.search(key).map((obj) => obj.item)
        }
      },
      setFilter() {
        this.filterList = this.customerList
      },
      handleChange() {
        try {
          window._axiosPromiseArr.forEach((ele, index) => {
            ele.cancel() // 清空（终止）正在请求的内容
            // 清空请求的参数 清空请求的参数
            delete window._axiosPromiseArr[index]
          })
        } catch (e) {}
        removeStationsId('stationId')
        removeEmsId('emsId')
        switchCustomer({ customerId: this.customerId }).then((res) => {
          if (res.data.code === 200) {
            this.$router.push({
              name: 'Index'
            })
            this.userWebConfig()
            this.collapse = this.customerId
            setCookie('customerId', this.customerId)
          }
        })
      },
      clickdesc() {
        this.$refs.updateDialog.dialogVisible = true
      },
      closeDesc() {
        this.DescTip = 'close'
        setCookie('setDescTip', 'close')
      },

      setLanguage() {
        const lang = getCookie('language') || 'zh'
        this.language = lang
      },
      choose(lang) {
        this.$i18n.locale = lang
        setCookie('language', lang)
        this.setLanguage()
      },
      handleScroll(e) {
        let top = e.target.scrollTop
        if (top > 800) {
          this.isActive = true
        } else {
          this.isActive = false
        }
      },

      toTop(step) {
        //参数step表示时间间隔的幅度大小，以此来控制速度
        //当回到页面顶部的时候需要将定时器清除
        document.getElementById('home_main').scrollTop -= step
        if (document.getElementById('home_main').scrollTop > 0) {
          var time = setTimeout(() => this.toTop(step), 15)
        } else {
          clearTimeout(time)
        }
      },
      handleError() {
        if (!this.homeLogoTitle) {
          this.title = this.$t('智慧储能云平台')
        }
      },
      userWebConfig() {
        getWebConfig({})
          .then((res) => {
            if (res.data.code === 200) {
              setCookie('config', res.data.data.bigScreenWeb)
              this.user = res.data.data.bigScreenWeb
              this.homeLogoUrl = res.data.data.homeLogoUrl
              this.homeLogoTitle = res.data.data.homeLogoTitle
              this.bigScreenMapRegion = res.data.data.bigScreenMapRegion
              if (!this.homeLogoUrl && !this.homeLogoTitle) {
                this.title = this.$t('智慧储能云平台')
              }
            }
          })
          .catch(() => {})
      },
      getListCustomers() {
        getListCustomers({})
          .then((res) => {
            if (res.data.code === 200) {
              let data = res.data.data
              this.customerList = data.list
              this.filterList = this.customerList
              this.initFuse(this.customerList)
              this.customerId = data.selectCustomerId
              setCookie('customerId', this.customerId)
            }
          })
          .catch(() => {})
      },
      clickFold() {
        this.isCollapse = !this.isCollapse
        setCookie('isCollapse', this.isCollapse)
        this.$nextTick(() => {
          setTimeout(() => {
            this.collapse++
          }, 500)
        })
      },
      handleScreen() {
        let bigScreenWeb = getCookie('config')
        if (bigScreenWeb === 'huayou') {
          const routeOne = this.$router.resolve({
            path: '/largeScreen'
          })
          window.open(routeOne.href, '_blank')
        } else if (this.bigScreenMapRegion === 'world') {
          const routeTwo = this.$router.resolve({
            path: '/statisticalScreen'
          })
          window.open(routeTwo.href, '_blank')
        } else {
          const routeTwo = this.$router.resolve({
            path: '/dataScreen'
          })
          window.open(routeTwo.href, '_blank')
        }
      },
      handleSelect(key, keyPath) {
        this.$router.push(key)
        let isCollapse = JSON.parse(getCookie('isCollapse')) || false
        this.$nextTick(() => {
          setTimeout(() => {
            if (!isCollapse) {
              if (key == '/stationCard') {
                this.isCollapse = true
              } else {
                this.isCollapse = false
              }
            } else {
              this.isCollapse = JSON.parse(getCookie('isCollapse')) || false
            }
          }, 500)
        })
      },
      handleCommand(command) {
        if (!getToken('Token')) {
          this.$router.push('/login')
        } else {
          if (command == '1') {
            this.logout()
          } else if (command == '2') {
            this.dialogFormVisible = true
          } else if (command == '3') {
            this.$refs.personalInfoDialog.dialogVisible = true
          }
        }
      },
      // 重置密码保存
      handlePwdSave() {
        this.$refs['pwdFormRef'].validate((valid) => {
          if (valid) {
            let params = {
              oldPassword: this.passwordForm.oldPassword,
              newPassword: this.passwordForm.newPassword
            }
            this.savePwdLoading = true
            userModifyPwd(params)
              .then((res) => {
                if (res.data.code === 200) {
                  this.handlePwdClose()
                  this.$confirm(this.$t('密码更改成功，请重新登录'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    showClose: false,
                    showCancelButton: false,
                    type: 'warning'
                  })
                    .then(() => {
                      this.$store.dispatch('resetAll')
                      this.$router.push('/login')
                    })
                    .catch(() => {})
                } else {
                  this.$message({
                    message: res.data.message,
                    type: 'error'
                  })
                }
              })
              .catch(() => {
                this.savePwdLoading = false
              })
          }
        })
      },
      handlePwdClose() {
        this.$refs['pwdFormRef'].resetFields()
        this.savePwdLoading = false
        this.dialogFormVisible = false
      },
      logout() {
        logout()
          .then((res) => {
            this.$store.dispatch('resetAll')
            this.$router.push('/login')
          })
          .catch(() => {
            this.$store.dispatch('resetAll')
            this.$router.push('/login')
          })
      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
      this.timer = null
    }
  }
</script>
<style>
  .eloption .el-select-dropdown__wrap {
    max-height: 21.8vw !important;
    width: 19.8vw;
  }
  .eloption .el-select-group .el-select-dropdown__item {
    margin: 0 30px 0 0;
  }
</style>
<style lang="scss" scoped>
  @import '../assets/style/common.scss';
  .anchor-list {
    position: absolute;
    right: 8px;
    top: -20px;
    transform: scale(0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 999;
    color: #909399;
    background-color: #fff;
    width: 20px;
  }
  .anchor-list span {
    margin-bottom: 5px;
    cursor: pointer;
  }
  ::v-deep .el-menu .el-tag {
    float: right;
    margin-top: 9px;
    border-radius: 10px;
    width: auto !important;
    height: 25px !important;
    line-height: 25px !important;
  }
  ::v-deep .el-tag.el-tag--warning {
    font-weight: 600;
    color: #f58700;
  }
  .udan-ems-wrapper {
    width: 100%;
    background-color: #f0f2f5;
    .scroll {
      position: fixed;
      right: 30px;
      bottom: 20px;
      z-index: 100;
      .top {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #f2f5f6;
        text-align: center;
        line-height: 50px;
        color: #1989fa;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
        i {
          font-size: 20px;
        }
      }
    }
    .el-header {
      padding: 0px;
      z-index: 100;
      width: 100%;
      height: 64px !important;
      position: fixed;
      .layout-header-main {
        display: flex;
        height: 66px;
        box-sizing: border-box;
        border-bottom: 2px solid #f0f2f5;
        .layout-header-left {
          width: 232px;
          background-color: #fff;
          font-size: 24px;
          font-weight: 600;
          font-style: italic;
          @include flex-center;
          .el-image {
            width: 90%;
            ::v-deep .image-slot {
              width: 100%;
              text-align: center;
            }
          }
        }
        .layout-header-left-en {
          font-size: 20px;
        }
        .layout-header-right {
          display: flex;
          padding: 0 24px;
          border-left: 2px solid #f0f2f5;
          flex: 1;
          background-color: #fff;
          .el-row {
            width: 100%;
            display: flex;
            align-items: center;
          }
          .layout-header-info-language {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            // cursor: pointer;
            .el-divider--vertical {
              margin: 0 24px 0 18px;
              height: 18px;
            }
          }
          .layout-header-notice {
            display: flex;
            align-items: center;
            .notice-title {
              font-weight: 600;
              color: #0c7aec;
              margin-right: 8px;
            }
            .notice-info {
              margin-left: 8px;
              color: #2c2c2c;
            }
          }
          .layout-header-update-description {
            flex: 1;
            height: 63%;
            .update-desc {
              height: 100%;
              width: 100%;
              background: linear-gradient(90deg, #e2e9fd 0%, #f3f3ff 100%);
              border-radius: 100px 100px 100px 100px;
              opacity: 1;
              display: flex;
              align-items: center;
              justify-content: space-around;
              .desc-left {
                width: 60%;
                height: 100%;
                display: flex;
                // justify-content: space-between;
                align-items: center;
                font-size: 16px;

                .icondiv {
                  display: flex;
                  align-items: center;
                  // margin-top: 7px;
                  margin-left: 5px;
                  // margin-right: 5px;
                  .svg-icon {
                    width: 30px !important;
                    height: 30px !important;
                  }
                }
                .title {
                  width: 150px;
                  height: 22px;
                  font-size: 16px;
                  font-family: HelloFont WenYiHei, HelloFont WenYiHei;
                  font-weight: 600;
                  color: #145ed4;
                  line-height: 22px;
                  letter-spacing: 1px;
                  word-break: normal;
                  white-space: nowrap;
                }
              }
              .desc-right {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100px;
                .desc-search {
                  width: 58px;
                  height: 24px;
                  background: linear-gradient(149deg, #145ed4 0%, rgba(20, 94, 212, 0.6) 99%);
                  border-radius: 26px 26px 26px 26px;
                  opacity: 1;
                  color: #ffffff;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 12px;
                  cursor: pointer;
                }
                .desc-close {
                  cursor: pointer;
                  width: 20px !important;
                  height: 20px !important;
                }
              }
            }
          }
          .language-select {
            ::v-deep .language-select-input {
              width: 120px;
              .el-input__inner {
                width: 120px;
                background: none !important;
                box-shadow: none;
                border: none;
                display: flex;
                align-items: center;
                padding-left: 30px;
              }
              .el-input__prefix {
                display: flex;
                align-items: center;
                span {
                  width: 14px;
                  height: 14px;
                }
                .svg-icon {
                  width: 14px;
                  height: 14px;
                }
              }
            }
            @media screen and (min-width: 1921px) {
              ::v-deep .language-select-input {
                width: 150px;
                .el-input__inner {
                  width: 150px;
                  background: none !important;
                  box-shadow: none;
                  border: none;
                  display: flex;
                  align-items: center;
                  padding-left: 30px;
                }
                .el-input__prefix {
                  display: flex;
                  align-items: center;
                  span {
                    width: 14px;
                    height: 14px;
                  }
                  .svg-icon {
                    width: 14px;
                    height: 14px;
                  }
                }
              }
            }
          }
          .layout-header-info {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            cursor: pointer;
            ::v-deep .el-dropdown {
              color: rgba(0, 0, 0, 0.85);
            }
            .el-avatar {
              width: 28px;
              height: 28px;
              margin-right: 8px;
            }
          }
        }
      }
    }

    .udan-ems-container {
      .el-aside {
        top: 65px;
        margin-top: 65px;
        height: calc(100vh - 65px);
        width: auto !important;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        background-color: #fff;
        .fold {
          display: flex;
          flex: 1;
          align-items: flex-end;
          width: max-content;
          margin-left: 20px;
          font-size: 12px;
          z-index: 1000;
          margin-bottom: 20px;
          .open-close {
            cursor: pointer;
          }
          i {
            font-size: 16px;
          }
          div {
            display: flex;
            align-items: center;
          }
        }
      }
      ::v-deep .el-menu-vertical-demo {
        width: 232px;
      }
      .el-aside-en {
        ::v-deep .el-menu--collapse {
          width: 64px !important;
        }
      }
      ::v-deep .el-menu--collapse {
        width: 64px;
        .el-tooltip {
          padding: 0 14px !important;
          .svg-icon {
            margin-right: 0px;
          }
        }
      }
      .el-main {
        padding: 24px;
        overflow: auto;
        height: calc(100vh - 65px);
        margin-top: 64px;
      }
      .el-menu {
        padding: 15px 8px;
        border-right: none;
        .el-menu-item {
          border-radius: 4px;
          padding-left: 15px !important;
          text-align: start;
          height: 42px;
          line-height: 42px;
          margin-bottom: 4px;
          color: #4b4b4b;
          overflow: hidden;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          position: relative;
          -webkit-line-clamp: 1;
          -o-text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          display: -moz-box;
          -moz-line-clamp: 1;
          -moz-box-orient: vertical;
          position relative .svg-icon {
            margin-right: 15px;
          }
          span {
            width: 100%;
            height: 16px;
            white-space: wrap;
            white-space: break-spaces;
            word-break: break-all;
          }
        }

        ::v-deep .el-menu-item-group__title {
          text-align: start !important;
          line-height: 42px;
          padding: 0 0 0 16px !important;
        }
        .close-title {
          padding: 20px 0;
          display: flex;
          justify-content: center;
          .line {
            width: 25px;
            height: 1px;
            border: 1px solid #f0f2f5;
          }
        }
        ::v-deep .el-menu-item:focus {
          background: none !important;
        }
        .el-menu-item.is-active {
          color: #fff !important;
          background-color: #0c7aec !important;
          border-radius: 4px;
        }
        .el-menu-item ::v-deep .el-tooltip {
          text-align: center;
          // padding: 0 !important;
        }
      }
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s ease;
    }
    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
    .dialog-amend {
      ::v-deep .el-dialog__header {
        height: 54px;
        padding: 0 24px !important;
        line-height: 54px;
        border-bottom: 1px solid #e8e8e8;
        .el-dialog__title {
          color: rgb(0 0 0 / 90%);
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
        }
      }
      ::v-deep .el-dialog__footer {
        text-align: center;
      }
    }
  }
</style>
